export default function formatDate(dateString) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
}
export function formatDateJJMMYYYY(isoDate) {
    // * sol 1 : sometimes doesn't do the convert
    // if (new Date(dateString)?.toLocaleDateString('en-GB') == 'Invalid Date')
    //     return '_______';
    // return new Date(dateString)?.toLocaleDateString('en-GB');
    // * SOL 2
    // if(isoDate=='2023-01-04T23:00:00.000Z') return 'AQAQA';
    if(isoDate){
        let date = new Date(isoDate);
        if(!(date instanceof Date) || isNaN(date.getTime())) {
            return '_______';
        }
        //return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
        return `${(date.getDate()).toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    }
    return '_______';
}

export function formatDateYYYY(isoDate) {
    // * sol 1 : sometimes doesn't do the convert
    // if (new Date(dateString)?.toLocaleDateString('en-GB') == 'Invalid Date')
    //     return '_______';
    // return new Date(dateString)?.toLocaleDateString('en-GB');
    // * SOL 2
    // if(isoDate=='2023-01-04T23:00:00.000Z') return 'AQAQA';
    console.log('isodate',isoDate);
    if(isoDate){
        let date = new Date(isoDate);
        if(!(date instanceof Date) || isNaN(date.getTime())) {
            return '_______';
        }
        return `${date.getFullYear()}`;
    }
    return '_______';
}

